import React, { useState } from "react";
import axios from "axios";

function App() {
  const [mode, setMode] = useState("video");
  const [videoUrl, setVideoUrl] = useState("");
  const [accountUsername, setAccountUsername] = useState("");
  const [platform, setPlatform] = useState("tiktok");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleAnalyze = async () => {
    setLoading(true);
    setResult(null);
    setErrorMessage("");

    let requestData = mode === "video"
      ? { video_url: videoUrl, title: title || null, description: description || null }
      : { account_username: accountUsername, platform };

    try {
      const endpoint = mode === "video" ? "analyze_video" : "analyze_account";
      const response = await axios.post(`http://127.0.0.1:8000/${endpoint}`, requestData, {
        headers: { "Content-Type": "application/json" },
      });
      setResult(response.data);
    } catch (error) {
      setErrorMessage("❌ Erreur lors de l'analyse. Vérifiez votre saisie.");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-950 via-black to-gray-900 text-white flex flex-col items-center">
      
      {/* 🟢 EN-TÊTE */}
      <header className="w-full py-6 text-center bg-gray-800 shadow-lg">
        <h1 className="text-4xl font-extrabold text-yellow-400 tracking-wide">🚀 ShadowLeverage AI</h1>
        <p className="text-gray-400 mt-2">Optimisation & Analyse avancée pour Créateurs de Contenu</p>
      </header>

      {/* 🟢 CONTAINER PRINCIPAL */}
      <main className="w-full max-w-7xl flex flex-col items-center space-y-10 p-6">
        
        {/* 🟢 CHOIX ANALYSE */}
        <div className="flex space-x-6">
          <button
            className={`px-8 py-4 rounded-xl font-semibold tracking-wide transition-all duration-300
              ${mode === "video" ? "bg-blue-600 scale-110 shadow-xl" : "bg-gray-700 hover:bg-gray-600"}`}
            onClick={() => setMode("video")}
          >
            🎥 Analyser une Vidéo
          </button>
          <button
            className={`px-8 py-4 rounded-xl font-semibold tracking-wide transition-all duration-300
              ${mode === "account" ? "bg-green-600 scale-110 shadow-xl" : "bg-gray-700 hover:bg-gray-600"}`}
            onClick={() => setMode("account")}
          >
            📊 Analyser un Compte
          </button>
        </div>

        {/* 🟢 FORMULAIRE D'ANALYSE */}
        <div className="w-full max-w-4xl bg-gray-800 p-8 rounded-xl shadow-lg border border-yellow-500">
          <h2 className="text-2xl font-bold text-yellow-400 mb-6 text-center">
            {mode === "video" ? "🎬 Analyse Vidéo IA" : "📈 Analyse de Compte IA"}
          </h2>

          {mode === "video" ? (
            <>
              <input
                type="text"
                placeholder="🔗 Lien de la vidéo"
                className="w-full p-4 bg-black border border-gray-700 rounded-lg text-gray-300 focus:ring-2 focus:ring-yellow-500 mb-4"
                value={videoUrl}
                onChange={(e) => setVideoUrl(e.target.value)}
              />
              <input
                type="text"
                placeholder="✍️ Titre (optionnel)"
                className="w-full p-4 bg-black border border-gray-700 rounded-lg text-gray-300 focus:ring-2 focus:ring-yellow-500 mb-4"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
              <textarea
                placeholder="📝 Description (optionnel)"
                className="w-full p-4 bg-black border border-gray-700 rounded-lg text-gray-300 focus:ring-2 focus:ring-yellow-500 mb-4"
                rows="3"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </>
          ) : (
            <>
              <input
                type="text"
                placeholder="📊 Nom d'utilisateur"
                className="w-full p-4 bg-black border border-gray-700 rounded-lg text-gray-300 focus:ring-2 focus:ring-green-500 mb-4"
                value={accountUsername}
                onChange={(e) => setAccountUsername(e.target.value)}
              />
              <select
                className="w-full p-4 bg-black border border-gray-700 rounded-lg text-gray-300 focus:ring-2 focus:ring-green-500 mb-4"
                value={platform}
                onChange={(e) => setPlatform(e.target.value)}
              >
                <option value="tiktok">TikTok</option>
                <option value="instagram">Instagram</option>
                <option value="youtube">YouTube</option>
              </select>
            </>
          )}

          <button
            onClick={handleAnalyze}
            className={`w-full py-4 rounded-xl font-semibold text-lg transition-all duration-300 shadow-lg 
              ${mode === "video" ? "bg-yellow-600 hover:bg-yellow-500" : "bg-green-600 hover:bg-green-500"}`}
          >
            {mode === "video" ? "🚀 Lancer l'Analyse Vidéo" : "📊 Lancer l'Analyse Compte"}
          </button>
        </div>

        {/* 🟢 AFFICHAGE DES RÉSULTATS */}
        {loading && <p className="text-yellow-400 text-lg animate-pulse">⏳ Analyse en cours...</p>}
        {errorMessage && <p className="text-red-500 text-lg">{errorMessage}</p>}
        {result && (
          <div className="w-full max-w-4xl p-6 bg-gray-900 rounded-xl shadow-lg border border-yellow-500">
            <h3 className="text-2xl font-bold text-yellow-400 mb-4 text-center">🔍 Résultats d'Analyse</h3>

            <div className="space-y-6 text-gray-300">
              <section>
                <h4 className="text-xl font-semibold text-blue-400">📈 Optimisation du Contenu</h4>
                <p>{result.advice}</p>
              </section>

              <section>
                <h4 className="text-xl font-semibold text-green-400">🔥 Analyse des Tendances</h4>
                <p>{result.trends || "Aucune tendance trouvée."}</p>
              </section>

              <section>
                <h4 className="text-xl font-semibold text-yellow-400">🚀 Prédiction de Performance</h4>
                <p>{result.prediction || "Aucune donnée disponible."}</p>
              </section>
            </div>
          </div>
        )}

      </main>
    </div>
  );
}

export default App;
